import { GaEventPayload } from './types';

export const dispatchGaEvent = (payload: Partial<GaEventPayload>) => {
  if (!window || !window.gtag) {
    return;
  }

  const { event: eventName, ...eventPayload } = payload;

  window.gtag('event', eventName || 'b2b_admin_portal.loaded', {
    pageUrlPath: window.location.pathname,
    eventPlatform: 'b2b',
    userLoggedIn: true,
    ...eventPayload
  });
};
